<template>
  <div>
    <b-card>
      <b-tabs pills card vertical nav-wrapper-class="w-10">
        <b-tab title="Process" active>
          <b-card-text>
            <h2>Process</h2>
            <o-form-wrapper
              v-model="item"
              :server-errors="_se"
              :v="$v.item"
              :schema="schema"
              :form-state="formState"
            >
              <o-widget-wrapper
                :schema="schema"
                name="name"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-text-field
                  v-model="item.name"
                  :form-state="formState"
                  name="name"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.name"
                ></o-text-field>
              </o-widget-wrapper>
              <o-widget-wrapper
                :schema="schema"
                name="roles"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <user-role-form-table
                  :value="allTransitionsPerState"
                  :validators="$v.item.roles"
                  :form-state="formState"
                  :label="schema.fields.roles.label"
                  :level="level + 1"
                  :server-errors="_se.roles"
                >
                </user-role-form-table>
              </o-widget-wrapper>
              <br />
            </o-form-wrapper>
          </b-card-text>
        </b-tab>
        <b-tab title="User Roles">
          <b-card-text>
            <h2>Edit User Roles</h2>
            <user-role-form-page-item></user-role-form-page-item>
          </b-card-text>
        </b-tab>
        <b-tab title="Flow">
          <b-card-text>
            <div>
              <b-card no-body>
                <b-tabs card>
                  <div class="row">
                    <div class="col-md-2">
                      <div class="container mt-4">
                        <ul class="list-group">
                          <li
                            @click="editItem(item, index)"
                            class="list-group-item d-flex"
                            :class="{ active: isActive == index }"
                            :key="index"
                            v-for="(item, index) in allItems"
                          >
                            <div class="align-self-start flex-fill">
                              {{ item.name }}
                            </div>
                            <div class="align-self-end">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-chevron-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-10">
                      <b-tab title="State" active>
                        <process-state-form-page-item
                          :itemProcessState="itemProcessState"
                        >
                        </process-state-form-page-item>
                      </b-tab>
                      <b-tab title="Trigger">
                        <process-trigger-form-page-item></process-trigger-form-page-item>
                      </b-tab>
                      <b-tab title="Transitions">
                        <template v-if="itemProcessState">
                          <process-transition-form-table
                            v-model="item.transition"
                            :validators="$v.item.transition"
                            :form-state="formState"
                            :label="schema.fields.transition.label"
                            :level="level + 1"
                            :server-errors="_se.transition"
                          >
                          </process-transition-form-table>
                        </template>
                        <template v-else>
                          <p>please select process state...</p>
                        </template>
                      </b-tab>
                    </div>
                  </div>
                </b-tabs>
              </b-card>
            </div>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../../vue-ocom/components/forms/fields/ODateTime";

import { default as UserRoleFormTable } from "../../user_role/components/ItemFormTable";
import { default as UserRoleFormPageItem } from "../../user_role/pages/FormPageItem";
import { default as ProcessStateFormPageItem } from "../../process_state/pages/FormPageItem";
import { default as ProcessTriggerFormPageItem } from "../../process_trigger/pages/FormPageItem";
import { default as ProcessTransitionFormPageItem } from "../../process_transition/pages/FormPageItem";
import { default as ProcessTransitionFormTable } from "../../process_transition/components/ItemFormTable";
import FormPageItem from "../../user_role/pages/FormPageItem.vue";
import { mapActions } from "vuex";
// import { default as UserRoleFormCards } from '../../user_role/components/ItemFormCards';

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("Process"),
    CreateCodeTableFetchMixin([]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,
    OCheckbox,
    OSelect,
    OTextField,
    UserRoleFormTable,
    UserRoleFormPageItem,
    ProcessStateFormPageItem,
    ProcessTriggerFormPageItem,
    ProcessTransitionFormTable,
    ProcessTransitionFormPageItem,
    FormPageItem,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.Process, {}),
    items: [],
    itemsTransition: [],
    isActive: null,
    itemProcessState: null,
  }),
  methods: {
    ...mapActions("ProcessStateModule", ["getAll"]),
    ...mapActions("ProcessTransitionModule", {
      getAllProcessTransition: "getAll",
    }),
    async getAllItems() {
      await this.getAll().then((res) => {
        this.items = _.cloneDeep(res.items);
      });
    },
    async getAllTransitions() {
      await this.getAllProcessTransition().then((res) => {
        this.itemsTransition = _.cloneDeep(res.items);
        console.log("getAllTransitions", res.items);
      });
    },
    async editItem(item, index) {
      this.isActive = index;
      this.itemProcessState = item;
    },
  },
  computed: {
    allItems() {
      return this.items;
    },
    allTransitionsPerState() {
      const filteredTransitions = this.itemsTransition.filter(
        (item) => item.from_state == this.itemProcessState.id
      );
      return filteredTransitions;
    },
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {
    itemProcessState(newVal, oldVal) {
      console.log("itemProcessState watch");
      this.getAllTransitions();
    },
  },
  created() {
    this.getAllItems();
    if (this.itemProcessState) {
      this.getAllTransitions();
    }
  },
};
</script>
